import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import Button from '@dojo/widgets/button';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { createNlsMiddleware, registry, userstate, landingChange, documentapi } from 'lcc-state';
import { QuizChoice } from '@holmescorp/lcc-app';
import { publish } from '@holmescorp/pub-sub';
import { resourceDitabookSelector } from '@holmescorp/resource-parser';

import css from '../css/survey.m.css';
import SurveyQuestions from '../support/questions';

export interface SurveyProperties {}

interface SurveyIcache {
	showQuestions: boolean;
}

const nls = createNlsMiddleware('landing');
const icache = createICacheMiddleware<SurveyIcache>();
const factory = create({
	theme,
	nls,
	userstate,
	icache,
	documentapi
}).properties<SurveyProperties>();

export const Survey = factory(({ middleware: { theme, nls, userstate, icache, documentapi } }) => {
	const themeCss = theme.classes(css);
	const { get: uget, path: upath } = userstate;

	const {
		messages: {
			header = '[landing] header',
			survey_confirm_quiz = '[landing] survey_confirm_quiz',
			survey_confirm_button = '[landing] survey_confirm_button',
			survey_quiz_type = '[landing] survey_quiz_type',
			survey_landing_invite_button = '[landing] survey_landing_invite_button',
			survey_a11y_description = '[landing] survey_a11y_description'
		}
	} = nls();

	const quizSelected = uget(upath('quizPattern'));
	const showQuestions = icache.getOrSet('showQuestions', false);

	const confirm_quiz_choice = () => {
		landingChange({ complete: true });
		publish('site/assessment', survey_quiz_type);
	};

	documentapi.setTitle(survey_a11y_description);

	return [
		quizSelected
			? v('div', { classes: [themeCss.root] }, [
					v('p', { classes: [themeCss.confirm] }, [survey_confirm_quiz]),
					w(QuizChoice, {}),
					w(Button, { onClick: confirm_quiz_choice }, [survey_confirm_button])
			  ])
			: showQuestions
			? v('div', { classes: [themeCss.root] }, [
					v('h3', { classes: [themeCss.header] }, [header]),
					w(SurveyQuestions, {})
			  ])
			: v('div', { classes: [themeCss.root], id: 'tabPanelAssess' }, [
					w(resourceDitabookSelector, {
						topic: 'assess_invite',
						key: 'assess-invite'
					}),
					v('div', {}, [
						w(
							Button,
							{
								onClick: () => {
									icache.set('showQuestions', true);
								}
							},
							[
								{
									label: survey_landing_invite_button
								}
							]
						)
					])
			  ])
	];
});

registry.define('LandingPageSurvey', Survey);
export default Survey;
